import React, { useEffect } from 'react';

import { checkPageTitle } from '../../../../store/actions/authentication';
import Routes from '../../routes';

const ProductMain: React.FC = (props: any) => {  
  useEffect(() => {
    checkPageTitle(props);
  },[props])
  
  return (
    <React.Fragment>
      <Routes />
    </React.Fragment>
  )
}

export default ProductMain;